import type { SxProps, Theme } from '@mui/material/styles'

import { metricCardShellLayoutSx } from '../../KestrixMetricCard/styles/kestrix-metric-card-shell.ts'

/**
 * Chart card shell: same layout chrome as metric cards, with a taller minimum height
 * for bar/pie chart content.
 */
export const chartCardShellLayoutSx = {
  ...metricCardShellLayoutSx,
  minHeight: '60vh',
  maxWidth: 'none'
} as const satisfies SxProps<Theme>
